import {
  EB_PRODUCT_NAME,
  CM_PRODUCT_NAME,
  CTFM_PRODUCT_NAME,
  BM_PRODUCT_NAME,
} from '@chegg-wt/core/constants/site'

// Using dynamic keys for siteName
export const navFeedback = {
  [EB_PRODUCT_NAME]: 'https://www.chegg.com/en/contactus/easybibsupport',
  [CM_PRODUCT_NAME]: 'https://www.chegg.com/en/contactus/citationmachinesupport',
  [CTFM_PRODUCT_NAME]: 'https://www.chegg.com/en/contactus/citethisformesupport',
  [BM_PRODUCT_NAME]: 'https://www.chegg.com/en/contactus/bibmesupport',
}

export const navHelpCenter = {
  [EB_PRODUCT_NAME]: 'https://www.chegg.com/en/contactus/easybibsupport',
  [CM_PRODUCT_NAME]: 'https://www.chegg.com/en/contactus/citationmachinesupport',
  [CTFM_PRODUCT_NAME]: 'https://www.chegg.com/en/contactus/citethisformesupport',
  [BM_PRODUCT_NAME]: 'https://www.chegg.com/en/contactus/bibmesupport',
}

export const legalCookieNotice = {
  [EB_PRODUCT_NAME]: 'https://www.chegg.com/en-US/cookienotice',
  [CM_PRODUCT_NAME]: 'https://www.citationmachine.net/resources/cookie-notice',
  [CTFM_PRODUCT_NAME]: 'https://www.citethisforme.com/resources/cookie-notice',
  [BM_PRODUCT_NAME]: 'https://www.chegg.com/cookie-notice',
}

export const legalInfoSellText = {
  [EB_PRODUCT_NAME]: 'Do Not Sell My Info',
  [CM_PRODUCT_NAME]: 'Manage Preferences',
  [CTFM_PRODUCT_NAME]: 'Manage Preferences',
  [BM_PRODUCT_NAME]: 'Manage Preferences',
}
